<script>
import Header from '@/components/Launchpad/PreSaleHeader';
import Countdown from '@/components/Launchpad/PreSaleCountdown';
import CardsCount from '@/components/Launchpad/CardsCount';
import Alert from '@/components/Launchpad/Alert';
import Order from '@/components/Launchpad/PreSaleOrder';
import Claim from '@/components/Launchpad/PreSaleClaim';
import dayjs from 'dayjs';
import { mapState, mapGetters } from 'vuex';
import { products } from '@/constants/launchpad';

export default {
  name: 'Presale',
  components: {
    Alert,
    Countdown,
    Header,
    CardsCount,
    Order,
    Claim,
  },
  async mounted() {
    if (this.chainId === this.saleChainId) {
      await this.$store.dispatch('Presale/getPresaleInfo', {
        tokenName: this.productParams.paymentToken,
        tokenId: this.productParams.tokenId || 1,
      });
    }
  },
  computed: {
    ...mapState({
      ethAddress: (state) => state.User.ethAddress,
      chainId: (state) => state.User.chainId,
    }),
    ...mapGetters('Presale', [
      'allowance',
      'price',
      'supply',
      'tokenId',
      'limit',
      'userTokensCount',
      'userTokensTotal',
      'closedAfter',
      'activeAfter',
      'paymentTokenName',
    ]),
    cardsLeft() {
      return Number(this.supply?.maxTotalSupply) - Number(this.supply?.currentSupply) || 0;
    },
    isAllowedChain() {
      return [1, 4, 56, 97, 43113, 43114].includes(this.chainId);
    },
    saleId() {
      return this.productParams.id;
    },
    saleCampaign() {
      return this.$route.params.pid;
    },
    saleChainId() {
      return this.productParams.chainId;
    },
    productParams() {
      return products[this.saleCampaign] || {};
    },
    showOrderForm() {
      return (
        dayjs().isAfter(dayjs.unix(this.activeAfter))
        && dayjs().isBefore(dayjs.unix(this.closedAfter))
      );
    },
  },
};
</script>

<template>
  <div class="main-wrap launchpad main-wrap--narrow">
    <div v-if="!isAllowedChain">
      <v-row justify="center">
        <h1>{{ $t('upcoming.ethereum-only') }}</h1>
      </v-row>
    </div>
    <div v-else-if="Object.keys(productParams).length === 0">
      <v-row justify="center">
        <h1>{{ $t('upcoming.no-products') }}</h1>
      </v-row>
    </div>
    <v-container class="mt-10 mb-5" v-else>
      <h1 class="launchpad__title text-center">Presale</h1>
      <Countdown :chain="chainId === saleChainId" />
      <Header :product="productParams" :chain="chainId === saleChainId" />
      <Alert :text="$t('launchpad.presale.alert', {limit: limit, total: userTokensTotal})" />
      <CardsCount :cards="cardsLeft" v-if="chainId === saleChainId" />
      <Order
        :limit="limit"
        :price="$BN(price).toString()"
        :paymentTokenIcon="productParams.paymentTokenIcon"
        :show="showOrderForm && chainId === saleChainId"
      />
      <Claim />
    </v-container>
  </div>
</template>

<style lang="scss">
.launchpad__title {
  font-size: 4.4rem;
}
</style>
